import React, { Fragment, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { H5, LI, UL } from "../../AbstractElements";
import SidebarSubMenu from "./SidebarSubMenu";
import { RootState } from "../../ReduxToolkit/Store";
import { Pinned } from "../../Utils/Constants";
import { SidebarMenuItem } from "../../Types/Layout.type";
import { menuList } from "../../Data/Layout/SidebarMenuList";

export default function SidebarNav() {
  const [activeMenu, setActiveMenu] = useState<string[]>([]);
  const { pinedMenu } = useSelector((state: RootState) => state.layout);
  const { user } = useSelector((state: RootState) => state.auth);

  // Filter menu items based on user permissions
  const filteredMenuList = useMemo(() => {
    // Helper function to check if user has permission to view a menu item
    const hasPermission = (permissionKey?: string) => {
      if (!permissionKey) return true; // No permission required
      if (!user || !user.permissions) return false; // No user or permissions
      return user.permissions[permissionKey]?.view === true;
    };

    return menuList
      .map((mainMenu) => ({
        ...mainMenu,
        items: mainMenu.items?.filter((item: any) =>
          hasPermission(item.permission),
        ),
      }))
      .filter((mainMenu) => mainMenu.items && mainMenu.items.length > 0);
  }, [user]);

  const shouldHideMenu = (mainMenu: SidebarMenuItem) => {
    return mainMenu?.items
      ?.map((data) => data.title)
      .every((titles) => pinedMenu.includes(titles || ""));
  };
  return (
    <UL className="sidebar-menu simple-list" id="simple-bar">
      <div className="simplebar-wrapper">
        <div className="simplebar-mask">
          <div className="simplebar-offset">
            <div className="simplebar-content-wrapper">
              <div className="simplebar-content">
                <LI
                  className={`pin-title sidebar-main-title ${
                    pinedMenu.length > 0 ? "show" : ""
                  } `}
                >
                  <div>
                    <H5 className="sidebar-title f-w-700">{Pinned}</H5>
                  </div>
                </LI>
                {filteredMenuList.map((mainMenu: any, index) => (
                  <Fragment key={index}>
                    <LI
                      className={`sidebar-main-title ${
                        shouldHideMenu(mainMenu) ? "d-none" : ""
                      }`}
                    >
                      <div>
                        <H5
                          className={`${
                            mainMenu.lanClass ? mainMenu.lanClass : ""
                          } f-w-700`}
                        >{`${mainMenu.title}`}</H5>
                      </div>
                    </LI>
                    <SidebarSubMenu
                      menu={mainMenu.items}
                      activeMenu={activeMenu}
                      setActiveMenu={setActiveMenu}
                      level={0}
                    />
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </UL>
  );
}
